export default "__VITE_ASSET__e58c15ab__"